import React from "react";
import { ObjectPanelElaborationWrapper } from "../../components/coobjects/ObjectPanelElaborationWrapper";
import { UserFunctionEnum } from "../../api/models/user-function-enum";
import { UnauthorizedError } from "../../components/generic/UnauthorizedError";
import { ProtectedComponent } from "../../components/wrappers/ProtectedComponent";
import { DocumentNotValidError } from "../../components/generic/DocumentNotValidError";
import { CoRetrieveDocumentData } from "../../components/generic/CoRetrieveDocumentData";
import { CoObjectSelector } from "../../components/generic/CoObjectSelector";

export const EditObjectPage: React.FunctionComponent = () => {
  return (
    <ProtectedComponent
      userFunction={UserFunctionEnum.MENU_EDIT_OBJECT}
      protectionType={true}
      errorComponent={<UnauthorizedError />}
    >
      <CoRetrieveDocumentData shouldFetchDocumentPart={true} shouldFetchDocumentPartMetadata={true}>
        {({ coObject, documentPart, documentPartMetadata }) =>
          coObject?.documentId ? (
            <CoObjectSelector documentPartMetadata={documentPartMetadata}>
              {(coObject) => (
                <ObjectPanelElaborationWrapper
                  isEdit={true}
                  documentPart={documentPart}
                  documentPartMetadata={documentPartMetadata}
                  coObject={coObject}
                />
              )}
            </CoObjectSelector>
          ) : (
            <DocumentNotValidError />
          )
        }
      </CoRetrieveDocumentData>
    </ProtectedComponent>
  );
};
